import { c as _c } from "react/compiler-runtime";
import { toast } from '@systemeio/ui';
import { useStoreQuery } from 'modules/stores/store/hooks/use-store-query';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
export const usePublisherErrorHandler = () => {
  const $ = _c(3);
  const {
    t
  } = useLocoTranslation();
  const {
    redirectToMainPage
  } = useStoreQuery();
  let t0;
  if ($[0] !== redirectToMainPage || $[1] !== t) {
    const internalErrorHandler = async () => {
      toast.error(t("core.error.internal_error_message"));
      await redirectToMainPage();
    };
    t0 = {
      internalErrorHandler
    };
    $[0] = redirectToMainPage;
    $[1] = t;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  return t0;
};